<script>
  import { AppController } from '../AppController';
  import { onMount } from 'svelte';
  import SectionHeader from '../components/SectionHeader.svelte';
  import ResidentFilter from '../components/ResidentFilter.svelte';
  import ResidentTable from '../components/ResidentTable.svelte';
  import {fade} from 'svelte/transition';
  import { showLoading } from '../components/Overlay.svelte';
  import { stickyToast } from '../components/Toast.svelte';

  onMount(async () => {
    try {
      showLoading(true);
      await AppController.getResidents();
    } catch(e) {
      stickyToast('danger', 'Error', 'An error occured while retrieving residents.');
    } finally {
      showLoading(false);
    }
  });
</script>
<div in:fade="{{duration: 1000}}">
  <SectionHeader section='Residents' subsection='All Residents'>
    <a class="btn btn-primary mt-2 mt-xl-0"  href="#/app/resident">
      Create resident
    </a>
  </SectionHeader>
  <ResidentFilter></ResidentFilter>
  <ResidentTable residents=residents></ResidentTable>
</div>

 
       
 

